import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function ChronicObstructivePulmonary(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-03-hepatitis-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Chronic obstructive pulmonary "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Chronic obstructive pulmonary disease (COPD) is a  <b>chronic inflammatory lung disease</b> that causes obstructed airflow from the lungs. Symptoms include
                                    breathing difficulty, cough, mucus (sputum) production and wheezing. Emphysema and chronic bronchitis are the most common conditions that make up COPD.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Chronic obstructive pulmonary disease/1.png")} alt="Chronic obstructive pulmonary disease" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b><a className='links' href="https://www.webmd.com/lung/copd/what-is-emphysema">Emphysema</a>:</b> This results from damage to your lungs’ air sacs (alveoli) that destroys the walls
                                    inside them and causes them to merge into one giant air sac. It can’t absorb oxygen as well,
                                    so you get less oxygen in your <a className='links' href='https://www.webmd.com/heart/anatomy-picture-of-blood'>blood</a>. Damaged alveoli can make your lungs stretch out and
                                    lose their springiness. Air gets trapped in your lungs and you can’t breathe it out, so you feel
                                    short of breath.

                                </p>
                                <p><b><a className='links' href='https://www.webmd.com/lung/copd/copd-chronic-bronchitis'>Chronic bronchitis:</a></b> If you have <a className='links' href='https://www.webmd.com/cold-and-flu/overview'>coughing</a>, shortness of breath, and <a className='links' href='https://www.webmd.com/allergies/features/the-truth-about-mucus'>mucus</a> that lingers at least
                                    3 months for 2 years in a row, you have chronic bronchitis. Hair-like fibers called cilia line your
                                    bronchial tubes and help move mucus out. When you have chronic bronchitis, you lose your
                                    cilia. This makes it harder to get rid of mucus, which makes you cough more, which creates
                                    more mucus.
                                    asthma. This type may also be called nonreversible. It doesn’t respond to normal asthma
                                    medications.</p>
                                <p><b><a className='links' href='https://www.webmd.com/asthma/default.htm'>asthma</a>:</b> This type may also be called nonreversible. It doesn’t respond to normal <a className='links' href='https://www.webmd.com/asthma/asthma-medications'>asthma
                                    medications</a>.</p>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p><b>Cough:</b> can be dry or with phlegm</p>
                                <p><b>Respiratory:</b> frequent respiratory infections, shortness of breath, or wheezing</p>
                                <p><b>Whole body:</b> fatigue or inability to exercise</p>
                                <p><b>Also common:</b> chest pressure, loss of muscle, or weight loss</p>
                                
                                <a className="links" href="https://en.wikipedia.org/wiki/Chronic_obstructive_pulmonary_disease">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default ChronicObstructivePulmonary;